"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNullEmptyOrUndefined = isNullEmptyOrUndefined;
exports.formatNumber = formatNumber;
exports.formatCurrency = formatCurrency;
exports.getFormattedDateLocalTZ = getFormattedDateLocalTZ;
exports.getFormattedDate = getFormattedDate;
exports.getSQLDate = getSQLDate;
exports.getSQLDateWithTime = getSQLDateWithTime;
exports.getMoneySymbol = getMoneySymbol;
exports.getSellDiscountTypeName = getSellDiscountTypeName;
exports.getPaymentDetailTypeName = getPaymentDetailTypeName;
exports.trimWithZeros = trimWithZeros;
exports.maskOrderNumber = maskOrderNumber;
exports.maskCuit = maskCuit;
exports.clearMask = clearMask;
exports.removeTypeNames = exports.diffYMDHMS = exports.compareValuesWithThreshold = exports.getIvaValue = exports.capitalizeFirstLetterEachWord = exports.capitalizeFirstLetter = exports.roundDin = exports.waitSecs = exports.isOpesi = exports.decode = exports.DINEROJS_ZERO = exports.isDineroObject = exports.din = exports.DATE_FORMATS = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _buffer = require("buffer");

var _moment = _interopRequireDefault(require("moment"));

var _dinero = _interopRequireDefault(require("dinero.js"));

var _Enums = require("./enums/Enums");

var DATE_FORMATS = ['DD/MM/YYYY', 'YYYY-MM-DD', 'YYYY-MM-DDTHH:mm:ss.SSSZ']; // just a short name and it converts the price to cents

exports.DATE_FORMATS = DATE_FORMATS;

var din = function din(price) {
  if (!price && price !== 0) return null; // i have to use toFixed(2) in the convertion because doing 8.2*100 results in 819.9999
  // so din creates an object resulting in 8.19
  // multiplies by 10000 since 4 digits are for decimal places

  return (0, _dinero["default"])({
    amount: parseInt(parseFloat(price * 10000).toFixed(2)),
    precision: 4
  });
};

exports.din = din;

var isDineroObject = function isDineroObject(number) {
  return number && number instanceof Object && number.getAmount && number.getPrecision;
};

exports.isDineroObject = isDineroObject;
var DINEROJS_ZERO = din(0);
exports.DINEROJS_ZERO = DINEROJS_ZERO;

function isNullEmptyOrUndefined(data) {
  return data === '' || data === null || data === undefined || (0, _typeof2["default"])(data) === 'object' && Object.keys(data).length == 0;
}
/**
 * Formats a number to have two decimals by default
 * @param {*} number
 * @param {*} hasDecimals
 */


function formatNumber(number) {
  var hasDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!number && number !== 0) return null;
  if (isNaN(number)) return NaN;

  if ((typeof Intl === "undefined" ? "undefined" : (0, _typeof2["default"])(Intl)) === 'object' && Intl && typeof Intl.NumberFormat === 'function') {
    var formatter = new Intl.NumberFormat('en-US', {
      currency: 'USD',
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: hasDecimals ? 2 : 0
    });
    return formatter.format(number);
  }

  return parseFloat("".concat(number.toLocaleString()));
}

function formatCurrency(number) {
  var hasDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var withSymbol = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var formatted;

  if (!number) {
    formatted = hasDecimals ? '0.00' : '0';
  } else {
    if (number && (0, _typeof2["default"])(number) === 'object') {
      return number.toFormat();
    }

    if (isNaN(parseFloat(number))) {
      formatted = 'NaN';
    } else {
      formatted = formatNumber(number, hasDecimals);
    }
  }

  return formatted ? withSymbol ? "$".concat(formatted) : "".concat(formatted) : '';
}

function getFormattedDateLocalTZ(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY HH:mm';
  return date && (0, _moment["default"])(date, DATE_FORMATS, true).local().format(format) || null;
}

function getFormattedDate(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'DD/MM/YYYY';
  if (!date) return null;

  var m = _moment["default"].utc(date, DATE_FORMATS, true);

  return m.isValid() && m.format(format) || null;
}

function getSQLDate(date) {
  if (!date) return null;

  var m = _moment["default"].utc(date, DATE_FORMATS, true);

  return m.isValid() && m.format('YYYY-MM-DD') || null;
}

function getSQLDateWithTime(date) {
  if (!date) return null;

  var m = _moment["default"].utc(date, DATE_FORMATS, true);

  return m.isValid() && m.format() || null;
}

var decode = function decode(payload) {
  if (!payload) return '';

  var _Buffer$from$toString = _buffer.Buffer.from(payload, 'base64').toString().split(':'),
      _Buffer$from$toString2 = (0, _slicedToArray2["default"])(_Buffer$from$toString, 2),
      type = _Buffer$from$toString2[0],
      id = _Buffer$from$toString2[1];

  return {
    type: type,
    id: id
  };
};

exports.decode = decode;

function getMoneySymbol(value) {
  switch (value) {
    case 'ARS':
      return '$';

    case 'USD':
      return 'USD';

    case 'EUR':
      return '€';

    default:
      return '$';
  }
}

function getSellDiscountTypeName(type) {
  if (!type) return '';

  switch (type) {
    case 'CLIENT_DISCOUNT':
      return 'DESCUENTO CLIENTE';

    case 'CUPON':
      return 'CUPON';

    case 'CREDIT_NOTE':
      return 'NOTA DE CRÉDITO';

    default:
      return '';
  }
}

function getPaymentDetailTypeName(type) {
  if (!type) return '';

  switch (type) {
    case 'CREDIT_CARD':
      return 'TARJETA CRÉDITO';

    case 'DEBIT_CARD':
      return 'TARJETA DÉBITO';

    case 'CHECK':
      return 'CHEQUE';

    case 'WIRE_TRANSFER':
      return 'TRANSFERENCIA BANCARIA';

    case 'CASH':
      return 'EFECTIVO';

    case 'WITHHOLDING':
      return 'RETENCIONES';

    case 'CN_APPLIED':
      return 'NC APLICADA';

    default:
      return '';
  }
}

function trimWithZeros(number, cantDigits) {
  if (cantDigits >= 0) {
    if (number.toString().length > cantDigits) {
      return number.toString().substring(number.toString().length - cantDigits, number.toString().length);
    } else {
      return number.toString().padStart(cantDigits, 0);
    }
  }

  return number && number.toString() || '';
}

var isOpesi = function isOpesi(sell) {
  return sell && (sell.type == 'SELL2' || sell.type == 'QUOTE_REQUEST2');
};

exports.isOpesi = isOpesi;

var waitSecs = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(s) {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              return setTimeout(function () {
                return resolve();
              }, s * 1000);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function waitSecs(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * redondea a 4 decimales un objeto dinero, si el valor resultante al redoondearlo a 2
 * decimales resulta en 0, retorna 0 xq al usar tantos decimales a veces se mandaba a la db 0.0001
 * @param {*} dinero
 */


exports.waitSecs = waitSecs;

var roundDin = function roundDin(dinero) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;
  if (!dinero) return null;
  var rounded = dinero.toRoundedUnit(decimals);
  if (parseFloat(rounded).toFixed(2) == 0) return 0;
  return rounded;
};

exports.roundDin = roundDin;

var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
  if (!string) {
    return '';
  }

  string = string.toLowerCase();
  return string.charAt(0).toUpperCase() + string.slice(1);
};

exports.capitalizeFirstLetter = capitalizeFirstLetter;

var capitalizeFirstLetterEachWord = function capitalizeFirstLetterEachWord(str) {
  if (!str) return '';
  var splitStr = str.toLowerCase().split(' ');

  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }

  return splitStr.join(' ');
};

exports.capitalizeFirstLetterEachWord = capitalizeFirstLetterEachWord;

var getIvaValue = function getIvaValue(taxType) {
  if (!taxType) {
    return null;
  }

  switch (taxType) {
    case _Enums.EnumTaxType.IVA_10_5:
      return 10.5;

    case _Enums.EnumTaxType.IVA_21:
      return 21;

    case _Enums.EnumTaxType.IVA_27:
      return 27;

    case _Enums.EnumTaxType.IVA_0:
      return 0;
  }
};
/**
 * value1-threshold% <= value2 <=valu1+threshold%
      return 0;
    } else if (value2 < low) {
      return -1;
    } else if (value2 > high) {
      return 1;
 * @param {*} value1 
 * @param {*} value2 
 * @param {*} threshold 
 */


exports.getIvaValue = getIvaValue;

var compareValuesWithThreshold = function compareValuesWithThreshold(value1, value2, threshold) {
  var useAsPercentage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var t = threshold / 100;
  var low = value1 * (1 - t);
  var high = value1 * (1 + t);

  if (useAsPercentage) {
    low = value1 * (1 - t);
    high = value1 * (1 + t);
  } else {
    low = value1 - threshold;
    high = value1 + threshold;
  }

  if (value2 <= high && low <= value2) {
    // low <= stock <= high
    return 0;
  } else if (value2 < low) {
    return -1;
  } else if (value2 > high) {
    return 1;
  }
};

exports.compareValuesWithThreshold = compareValuesWithThreshold;

function maskOrderNumber(value) {
  if (typeof value !== 'string') {
    return '';
  }

  var maskedValue = value.replace(/\D/g, '');

  if (maskedValue.length > 4) {
    maskedValue = maskedValue.replace(/^(\d{4})(\d{1,8}).*/, '$1-$2');
  }

  return maskedValue;
}

function maskCuit(value) {
  if (typeof value !== 'string') {
    return '';
  }

  var maskedValue = value.replace(/\D/g, '');

  if (maskedValue.length > 10) {
    return maskedValue.replace(/^(\d{2})(\d{1,8})(\d{1}).*/, '$1-$2-$3');
  } else if (maskedValue.length > 2) {
    return maskedValue.replace(/^(\d{2})(\d{1,8}).*/, '$1-$2');
  }

  return maskedValue;
}

function clearMask(value) {
  if (typeof value !== 'string') {
    return '';
  }

  return value.replace(/[^A-Z0-9]/gi, '');
}

var diffYMDHMS = function diffYMDHMS(date1, date2) {
  if (!date1 || !date2) return {
    years: 0,
    months: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  };
  var start = (0, _moment["default"])(date2, DATE_FORMATS);
  var end = (0, _moment["default"])(date1, DATE_FORMATS);
  if (!start.isValid() || !end.isValid()) throw 'INVALID DATES';
  var years = start.diff(end, 'year');
  end.add(years, 'years');
  var months = start.diff(end, 'months');
  end.add(months, 'months');
  var days = start.diff(end, 'days');
  end.add(days, 'days');
  var hours = start.diff(end, 'hours');
  end.add(hours, 'hours');
  var minutes = start.diff(end, 'minutes');
  end.add(minutes, 'minutes');
  var seconds = start.diff(end, 'seconds');
  return {
    years: years,
    months: months,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
};

exports.diffYMDHMS = diffYMDHMS;

var removeTypeNames = function removeTypeNames(obj) {
  if ((0, _typeof2["default"])(obj) !== 'object' || obj == null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(function (val) {
      return removeTypeNames(val);
    });
  }

  return Object.keys(obj).reduce(function (acc, key) {
    if (key === '__typename') {
      return acc;
    }

    var value = obj[key];

    if (Array.isArray(value)) {
      acc[key] = value.map(function (val) {
        return removeTypeNames(val);
      });
    } else {
      acc[key] = removeTypeNames(obj[key]);
    }

    return acc;
  }, {});
};

exports.removeTypeNames = removeTypeNames;